import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { noop } from "nodash"
import { selectActiveLayerId } from "panels/content/side-panel/slice.new"
import { selectUploadsForSet } from "./IconSlice"
import { selectActivatedFireId } from "features/map/control/selectors"

export const useIconProcessing = () => {
    const dispatch = useAppDispatch()
    const fireId = useAppSelector(selectActivatedFireId) || ""
    const activeLayerId = useAppSelector(selectActiveLayerId) || ""
    const uploads = useAppSelector(selectUploadsForSet(activeLayerId))

    const canProcessPlugin = () => {
        return false
    }

    return {
        canProcessPlugin,
        processCallback: noop,
        dependencies: [dispatch, uploads, fireId, activeLayerId],
    }
}
